import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'react-bootstrap';

const keywordList = {
  '[DEVICE_NAME]': {
    description: 'Name of device being monitored.',
  },
  '[SENSOR_NAME]': {
    description: 'Name of the sensor being monitored.',
  },
  '[CHANNEL_TYPE]': {
    description: 'Type of channel being monitored.',
  },
  '[SENSOR_PORT]': {
    description: 'Port of the sensor being monitored.',
  },
};

const AlertNamingModal = ({
  show, onHide, onSelect, hasMaxDevice = false,
}) => {
  const computedKeywordList = React.useMemo(() => {
    const entries = Object.entries(keywordList);
    if (hasMaxDevice) {
      entries.splice(1, 0, [
        '[COMPONENT_NAME]',
        { description: 'Additional context for MAX devices. (Will be blank for PRO devices.)' },
      ]);
    }
    return Object.fromEntries(entries);
  }, [hasMaxDevice]);

  const handleKeywordClick = (keyword) => {
    onSelect(keyword);
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Alert Naming Keywords</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="table-responsive">
          <table className="table table-condensed table-striped small">
            <thead>
              <tr>
                <th>Keyword</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(computedKeywordList).map(([keyword, value]) => (
                <tr key={keyword}>
                  <td>
                    <Button
                      variant="link"
                      onClick={() => handleKeywordClick(keyword)}
                    >
                      {keyword}
                    </Button>
                  </td>
                  <td>{value.description}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

AlertNamingModal.defaultProps = {
  hasMaxDevice: false,
};
AlertNamingModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  hasMaxDevice: PropTypes.bool,
};

export default AlertNamingModal;
